/**
 * @file routes/_app/settings/contract-sources.tsx
 * @description 合約來源字典維護頁。
 *
 * 此頁編輯的字典項會出現在「組織客戶檔案 → 編輯客戶 → 合約來源」下拉選單。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/contract-sources')({
  component: ContractSourcesPage,
});

/** 合約來源維護頁 */
function ContractSourcesPage() {
  return (
    <LookupAdminPage
      resource="contract-sources"
      resourceLabel="合約來源"
      description="維護「編輯客戶 → 合約來源」下拉選單的候選項（如中華驗證 / 客戶推薦 …）。"
      nameMaxLength={50}
    />
  );
}
